<template>
  <!-- Change viewBox and fill params -->
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 32 32"
  >
    <g :fill="color" :stroke="color" class="fill-current stroke-current">
      <path
        fill="#fff"
        d="M32 16c0 8.837-7.163 16-16 16s-16-7.163-16-16c0-8.837 7.163-16 16-16s16 7.163 16 16z"
      />
      <path
        fill="#09104a"
        d="M18.341 10.274h1.912v-3.227c-0.808-0.091-1.745-0.143-2.694-0.143-0.032 0-0.064 0-0.097 0h0.005c-0.094-0.007-0.204-0.011-0.314-0.011-2.401 0-4.347 1.946-4.347 4.347 0 0.152 0.008 0.303 0.023 0.451l-0.002-0.019v2.843h-3.040v3.606h3.040v9.078h3.726v-9.078h2.918l0.464-3.608h-3.382v-2.49c0-1.037 0.29-1.75 1.787-1.75z"
      />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      default: ''
    },
    height: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: ''
    }
  }
}
</script>
